import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { Paper } from '@material-ui/core'

const ConfirmDialog = (props) => {
    const { title, question, onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);


    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);



    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div>
            <Dialog
                maxWidth="xs"
                open={open}
                {...other}
            >
                <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
                <DialogContent dividers>
                    {question}
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCancel} color="primary">
                        Cancel
        </Button>
                    <Button onClick={handleOk} color="primary">
                        Ok
        </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ConfirmDialog
